import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import './Dashboard.scss';

export type TooltipContentProps = {
    position: 'left-start' | 'bottom-start';
};

export function TooltipContent({ position }: TooltipContentProps) {
    const { t } = useTranslation(['dashboard_cards']);
    return (
        <div className={`dashboard-page--tooltip-legacy dashboard-page--tooltip-legacy__${position}`}>
            <h2>
                <Trans ns="dashboard_cards" i18nKey="legacy_edit_header" components={{ wbr: <wbr /> }} />
            </h2>
            <p>{t('dashboard_cards:legacy_edit_content')}</p>
            {/*    /!* TODO: Add the original button back once we have an action for it *!/*/}

            {/*<div className="dashboard-page--tooltip-legacy__buttons">*/}
            {/*    <button disabled style={{ cursor: 'default' }} />*/}
            {/*    /!* <button>*/}
            {/*        <span>*/}
            {/*            {t('dashboard_cards:legacy_edit_learn_more')}*/}
            {/*            <RedirectSVG />*/}
            {/*        </span>*/}
            {/*    </button> *!/*/}
            {/*</div>*/}
        </div>
    );
}
